import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import Dashboard from '../components/Repair_Tickets/Dashboard';
import EditRepairTicket from '../components/Repair_Tickets/EditRepairTicket';
import RepairTicketList from '../components/Repair_Tickets/RepairTicketList';
import ViewRepairTicket from '../components/Repair_Tickets/ViewRepairTicket';



const Repair_Tickets = () => {
  return (
    <Routes>
      <Route path="/" element={<RepairTicketList />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/edit" element={<EditRepairTicket />} />
      <Route path="/edit/:id" element={<EditRepairTicket />} />
      <Route path="/view/:id" element={<ViewRepairTicket />} />
    </Routes>
  )
}

export default Repair_Tickets;